"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DialogTrigger: function() {
        return _index.DialogTrigger;
    },
    renderDialogTrigger_unstable: function() {
        return _index.renderDialogTrigger_unstable;
    },
    useDialogTrigger_unstable: function() {
        return _index.useDialogTrigger_unstable;
    }
});
const _index = require("./components/DialogTrigger/index");
